import { VoicemailTableDataRow } from '../all-calls/types';

export const getTranscriptionUniqueKey = (row?: VoicemailTableDataRow) => {
  return row ? `${row.channelId}-${row.mailboxId}-${row.mediaId}-${row.voicemailId}` : '';
};
